import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { LabCultureResultHeaderApi } from '../api/labcultureresultheader.api';
import { switchMap, map } from 'rxjs/operators';
import { LabCultureResultHeaderData, LabCultureResultHeader } from '../../../interfaces/masters/labcultureresultheader';

@Injectable()
export class LabCultureResultHeaderService extends LabCultureResultHeaderData  { 
  constructor(private api: LabCultureResultHeaderApi) {
    super();
  }
  
  list(): Observable<LabCultureResultHeader[]> {
    return this.api.list();
  }

  getById(url:string): Observable<LabCultureResultHeader>{
      return this.api.getById(url);
  }

  create(url: string, data:LabCultureResultHeader): Observable<LabCultureResultHeader> {
    return this.api.add(url,data);
  }

  update(url: string, data:LabCultureResultHeader): Observable<LabCultureResultHeader> {
    return this.api.update(url,data);
  }  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
